import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

export function TechnicalCommercialCapabilities({ capabilities, cameraExpertise, media = [] }) {
  return (
    <section id="capabilities" className="section compact-capabilities-section" data-slide="05" data-testid="compact-capabilities-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="compact-capabilities-overline">{capabilities.overline}</p>
        <h2 data-testid="compact-capabilities-title">{capabilities.title}</h2>
        <p data-testid="compact-capabilities-description">{cameraExpertise.description}</p>
      </div>

      <div className="compact-capability-grid" data-testid="compact-capability-grid">
        {capabilities.columns.map((column, index) => (
          <article className="matrix-column compact" key={column.title} data-testid={`compact-capability-column-${index + 1}`}>
            <CardMediaSlot image={media[index]?.image} label={column.title} testId={`compact-capability-media-${index + 1}`} className="compact-media" />
            <span className="matrix-number" data-testid={`compact-capability-number-${index + 1}`}>{String(index + 1).padStart(2, "0")}</span>
            <h3 data-testid={`compact-capability-title-${index + 1}`}>{column.title}</h3>
            <ul data-testid={`compact-capability-list-${index + 1}`}>
              {column.items.slice(0, 5).map((item) => (
                <li key={item} data-testid={`compact-capability-item-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
        <article className="expertise-card stat-card compact-stat" data-testid="compact-camera-activity-card">
          <span data-testid="compact-camera-activity-number">{cameraExpertise.activity.number}</span>
          <h3 data-testid="compact-camera-activity-title">{cameraExpertise.activity.title}</h3>
          <p data-testid="compact-camera-activity-text">{cameraExpertise.iq.text}</p>
        </article>
      </div>
    </section>
  );
}